import { styled } from "styled-components";

export const TitleLegal = styled.p`
    font-family: Suburban;
    font-size: 2rem;
`;

export const SubtitleLegal = styled.p`
    font-family: Roboto-Thin;
    font-size: 1rem;
`;

export const SectionTitleLegal = styled.p`
    font-family: Roboto-Bold;
    font-size: 1.2rem;
`;

export const DescriptionLegal = styled.p`
    font-family: Roboto-Light;
    font-size: 0.9rem;
    line-height: 1.5
`;

export const ListLegal = styled.li`
    font-family: Roboto-Light;
    font-size: 0.9rem;
    line-height: 1.5
`;